
import toastr from 'toastr';

angular.module("political_affiliations")

    .controller("PoliticalAffiliationsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("POLITICAL_AFILIATION_WRITE");

        $rootScope.title = $filter('translate')('political_affiliations.title');        
        $rootScope.breadcrumb = [
            { title: $filter('translate')('political_affiliations.title') }
        ];

        $scope.gridOptionsPoliticalAffiliations = {
            pdfTitle: "Afiliaciones políticas",
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,            
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            exporterSuppressColumns: ["image_id"], //la eliminamos porque no funciona con la url, probar con base64 si se quiere.
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },                
                {
                    field: 'image_id',
                    enableSorting: false,
                    width: 60,
                    enableFiltering: false,
                    displayName: $filter('translate')('political_affiliations.logo'),
                    cellTemplate: "<div style='height: 28px; overflow: hidden; text-align: center'><img width=\"28px\" ng-show=\"grid.getCellValue(row, col)\" ng-src=\"/api/Image/GetImageBmp?id={{row.entity.image_id}}&maxW=28&maxH2=28\" style=\"margin-top:0px\" lazy-src></div>"
                },
              { name: 'name', displayName: $filter('translate')('political_affiliations.name'), enableFiltering: true, enableHiding: false },
              { name: 'order_afiliation', displayName: $filter('translate')('political_affiliation.order'), enableFiltering: false, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('political_affiliations.button_edit'), action: 'ui-sref="political_affiliations.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('political_affiliations.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                var deferred = $q.defer();
                Restangular.all('PoliticalAffiliations').getList(options).then(function (results) {
                    deferred.resolve(results);
                });
                return deferred.promise;
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("political_affiliations.edit", { id: rowEntity.id });
        }



        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('political_affiliations.delete'),
                message: $filter('translate')('political_affiliations.delete_message')+" " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('PoliticalAffiliations', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('political_affiliations.delete_success'));
                        $scope.gridOptionsPoliticalAffiliations.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
    }])

;